import Debug from '../helpers/debug.js';
import { baseApiBuilder } from '../helpers/baseBuilder.js';
import { schedules } from './schedules/index.js';

const debug = Debug('commands:schedules');
const command = 'schedules <action>';

const desc = 'Manage schedules';

const builder = async function (yargs) {
  debug('builder', command);
  const base = await baseApiBuilder(yargs);
  return base.command(schedules);
};

const handler = async function (argv) {
  debug('handler', command, argv);
};

export { command, desc, builder, handler };
